import React from 'react';
import StyledModal from 'component/Modal/styled/Modal.style';
import StyledModalForm from 'component/form/ModalForm.style';
import styled from 'styled-components';
import { ModalContext } from 'component/Modal/modalContext';
import { useHistory } from "react-router-dom";

const Styled = {
  Container: styled.div`
  `,
  ButtonGroup: styled(StyledModalForm.ButtonGroup)`
      margin-top: 5em;
  `,
  Button: styled(StyledModalForm.Button).attrs({ type: 'button' })`
      &.gray {
          background-color: #9a9ba0;
          &.bordered {
              border: 1px solid #9a9ba0;
              background-color: transparent;
              color: #9a9ba0;
          }
      }
      &.primary {
          background-color: #485cc7;
      }
  `,
};

const AiSpkUpgradeModal = ({ title, desc, btnType }) => {
  let { handleModal } = React.useContext(ModalContext);
  const history = useHistory();

  const goToPlan = () => {
    handleModal();
    history.push('/plan');
  };

  return (
    <Styled.Container>
      <StyledModal.H2>멤버십 업그레이드 필요</StyledModal.H2>
      <StyledModal.Text>AI Conversation 서비스는 유료 회원만 이용 가능합니다.<br/>
        업그레이드하고 한국어 원어민 AI와 자유롭게 대화해요!</StyledModal.Text>
      <Styled.ButtonGroup>
        <Styled.Button className="gray bordered" onClick={() => handleModal()}>닫기</Styled.Button>
        <Styled.Button className="primary" onClick={goToPlan}>Plan 보기</Styled.Button>
      </Styled.ButtonGroup>
    </Styled.Container>
  );
};

export default AiSpkUpgradeModal;
